//import "leaflet/dist/leaflet-src" // Leaflet utilies for map
//import "leaflet.markercluster/dist/leaflet.markercluster-src"
import $ from "jquery";
import "leaflet/dist/leaflet-src" // Leaflet utilies for map
import "leaflet.markercluster/dist/leaflet.markercluster-src"
import "geoportal-extensions-leaflet/dist/GpPluginLeaflet-src"

// TODO debug geoportal : Uncaught ReferenceError: proj4 is not defined
//import "geoportal-extensions-leaflet/dist/GpPluginLeaflet-src" // Leaflet utilies for map

/**
 * 7.0 -- Module pour initialiser la maps des annuaires
 * @constructor
 */
$(document).ready(function() {

    // @aggul/jquery.serializeobject
    $.fn.serializeObject = function () {
        "use strict";

        var result = {};
        var extend = function (i, element) {
            var node = result[element.name];

            // If node with same name exists already, need to convert it to an array as it
            // is a multi-value field (i.e., checkboxes)

            if ('undefined' !== typeof node && node !== null) {
                if ($.isArray(node)) {
                    node.push(element.value);
                } else {
                    result[element.name] = [node, element.value];
                }
            } else {
                result[element.name] = element.value;
            }
        };

        $.each(this.serializeArray(), extend);
        return result;
    };

    RESCRA.Maps = function () {

        let self = this;
        let mapId = "directory-map";
        let listId = "directory-list";

        let GEO_RESULT_MODE = "geo";
        let CARD_LIST_RESULT_MODE = "card-list";

        let searchResult;
        let searchResultIntervalId;

        // map leaflet
        let map;

        // variables related to the marker to open
        let cardToOpenId;
        let cardToOpenLatitude;
        let cardToOpenLongitude;
        let cardToOpenGpsType;
        let cluster;
        let markerToOpen;
        let markerIntervalId; // use SetInterval coz the marker is added after page is loaded and we don't know how long it takes
        let geoSearch;
        let countySearch;

        this.init = function () {
            this.loadData();
            this.forceRenderMapIfCurrentMode();
        }

        this.forceRenderMapIfCurrentMode = function () {
            if (RESCRA_DIRECTORY_IS_MAP_DIRECTLY_ACTIVATED) {
                this.start();
            }
        }

        this.start = function () {
            searchResultIntervalId = setInterval(this.initMap, 500);
        }

        // this.end = function() {
        //     L.map(mapId).remove();
        // }

        $(".switch-map-list").on("click", function () {
            if ($("#" + mapId).hasClass("is-closed")) {
                self.switchToMap();
            } else {
                // self.end();
                $("#" + mapId).addClass("is-closed");
                $("#" + listId).removeClass("is-closed");
                let $switch = $(".switch-map-list");
                $switch.addClass("rescra-icon-map").removeClass("fa fa-list");
                //$switch.tooltip('dispose').prop('title', $switch.data('title-to-map')).tooltip('show');
                $("#result-mode-hidden-field").val(CARD_LIST_RESULT_MODE);
            }
        });

        this.switchToMap = function () {
            let $switch = $(".switch-map-list");
            $("#" + mapId).removeClass("is-closed");
            $("#" + listId).addClass("is-closed");
            $switch.addClass("fa fa-list").removeClass("rescra-icon-map");
            //$switch.tooltip('dispose').prop('title', $switch.data('title-to-list')).tooltip('show');
            $("#result-mode-hidden-field").val(GEO_RESULT_MODE);
            self.start();
        }

        $(".open-map-with-selected-card").on("click", function (event) {
            event.preventDefault();
            cardToOpenId = $(this).data("cardtoopenid");
            cardToOpenLatitude = $(this).data("cardgpslatitude");
            cardToOpenLongitude = $(this).data("cardgpslongitude");
            cardToOpenGpsType = $(this).data("cardgpstype");

            self.switchToMap();
        });

        //Requete du fichier Json
        //param string
        //return void;
        this.loadData = function () {

            if (searchResult === undefined) {
                let searchData = $(".rescra-form form").serializeObject();
                geoSearch    = searchData['filters[geo_search]'];
                countySearch = searchData['filters[county][]'];
                $.ajax({
                    url: RESCRA_SEARCH_MAP_DATA_URL,
                    method: 'post',
                    data: searchData
                }).done(function (data) {
                    searchResult = data.result;
                }).fail(function () {
                    console.error("error: contact the administrator");
                });
            }
        }

        this.initMap = function () {

            if (searchResult !== undefined) {
                clearInterval(searchResultIntervalId);
                clearInterval(markerIntervalId);
                if (RESCRA.Config.Env.Current === RESCRA.Config.Env.Dev) {
                    console.log("Coordonnées de la recherche", searchResult.top_left_coordinates);
                    console.log("recherche", searchResult);
                }

                let top_left_coordinates = searchResult.top_left_coordinates;
                if (top_left_coordinates === undefined &&
                    cardToOpenLatitude !== undefined &&
                    cardToOpenLongitude !== undefined &&
                    cardToOpenGpsType !== undefined) {
                    top_left_coordinates = {
                        'latitude': cardToOpenLatitude,
                        'longitude': cardToOpenLongitude,
                        'type': cardToOpenGpsType,
                    };
                }

                if (geoSearch !== '' || countySearch !== undefined) {
                    top_left_coordinates = {
                        'latitude': searchResult.card_list[0].coordinatesGPS.coordinates[1],
                        'longitude': searchResult.card_list[0].coordinatesGPS.coordinates[0],
                        'type': searchResult.card_list[0].type,
                    };
                }

                self.createMap(top_left_coordinates);
                let cluster = self.initCluster();
                self.createMarkersClusters(map, cluster, searchResult.card_list, searchResult.mobile_list, cardToOpenId);
            }
        }


        this.openMarkerPopup = function () {
            if (markerToOpen !== undefined) {
                clearInterval(markerIntervalId);
                var visibleOne = cluster.getVisibleParent(markerToOpen);
                if (typeof visibleOne.spiderfy !== "undefined") {
                    visibleOne.spiderfy();
                }
                markerToOpen.openPopup();
            }
        }

        //Crée et affiche la map,dans un element html préexistant trouver a partir de l'id
        //param String, String
        //return Map
        this.createMap = function (initialCoordinates) {
            //preparation des service de tiles

            // Lyon latitude / longitude
            let initPosition = (initialCoordinates !== undefined) ? [initialCoordinates.latitude, initialCoordinates.longitude] : [45.76082, 4.8381];

            if (map === undefined) {
                //preparation du service de tiles
                //if (RESCRA.Config.Env.Current !== RESCRA.Config.Env.Prod) {
                    //fournisseur de tiles OSM en dev
                    let osmUrl = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWVsa2l1cyIsImEiOiJjbGZ3amhpNHAwaTA3M2NzNmx3dHAwZWdzIn0.EHxFcoleBGiUF-f6q3og0w';
                    let osmAttrib = 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';

                    let osm = L.tileLayer(osmUrl, {
                        tileSize: 512,
                        zoomOffset: -1,
                        attribution: osmAttrib,
                        id: 'mapbox/streets-v11'
                    });

                    map = L.map(mapId, {
                        // center: initPosition,
                        // zoom:18,
                        maxZoom: 18,
                        layers: [osm]
                    });

                /*} else {
                    //fournisseur de tiles IGN
                    //IGN plan
                    var layerIGNPlan = L.geoportalLayer.WMS({
                        layer: "GEOGRAPHICALGRIDSYSTEMS.PLANIGN",
                        apiKey: "deq39a4jzr5ishxecwbg428g"
                    });

                    // Hack pour gérer le protcole https
                    var layerIGNPlanUrl = layerIGNPlan._url.replace('http:', window.location.protocol);
                    layerIGNPlan.setUrl(layerIGNPlanUrl);

                    //creation de la map
                    map = L.map(mapId, {
                        // center: initPosition,
                        // zoom: 13,
                        maxZoom: 18,
                        layers: [layerIGNPlan]
                    });
                }*/
            }

            markerIntervalId = setInterval(this.openMarkerPopup, 1000);

            map.setView(initPosition, 13);
        }

        //cluster des marker Fiche
        this.initCluster = function () {
            cluster = L.markerClusterGroup({
                //Cluster personalisée
                iconCreateFunction: function (cluster) {
                    return L.divIcon({
                        html: '<div class="myclusterShadow"></div> <b class="myCluster">' + cluster.getChildCount() + '<b>'
                    });
                }
            });
            return cluster;
        }

        //crée des cluster (ensemble de marker qui se regroupe)
        //param Map, Array<PS>
        //return void
        this.createMarkersClusters = function (map, cluster, cardList, mobileList, cardToOpenId) {
            if (RESCRA.Config.Env.Current === RESCRA.Config.Env.Dev) {
                console.log("createMarkersClusters");
            }
            let propCluster = {
                chunkerLoading: true,
                animate: true,
                animateAddingMarkers: true
            }

            map.addLayer(cluster);

            cardList.forEach(function (card) {
                if (RESCRA.Config.Env.Current === RESCRA.Config.Env.Dev) {
                    //console.log(card);
                }
                if (card.coordinatesGPS !== undefined && card.coordinatesGPS !== null) {
                    let icon = self.buildIcon(card.platform_list);
                    let marker = self.createMarker(map, card.coordinatesGPS.coordinates, icon);
                    marker = self.buildPopupContent(marker, card);
                    cluster.addLayer(marker);

                    if (card.id === cardToOpenId) {
                        markerToOpen = marker;
                    }
                }
            });


            mobileList.forEach(function (mobileInfo) {
                let card = mobileInfo.card;
                let place = mobileInfo.place;

                if (place.institution !== null &&
                    place.institution !== undefined &&
                    place.institution.coordinatesGPS !== undefined &&
                    place.institution.coordinatesGPS !== null) {
                    let icon = self.buildIcon(card.platform_list);
                    let marker = self.createMarker(map, place.institution.coordinatesGPS.coordinates, icon);
                    marker = self.buildPopupContent(marker, card, place);
                    cluster.addLayer(marker);
                }
            });
        }

        //Build card icon
        //param Map, card
        //return Icon
        this.buildIcon = function (platformList) {
            let color = "";
            if (platformList !== undefined && platformList.length === 1) {
                color = platformList[0].theme;
            }

            return L.divIcon({
                html: '<span class="' + color + ' rescra-map-marker fa fa-map-marker fa-3x"><span>'
            });
        }

        //Crée un marker
        //param Map, card
        //return Marker
        this.createMarker = function (map, coordinatesGPS, icon) {
            let coordonee = {lat: coordinatesGPS[1], lng: coordinatesGPS[0]};
            let marker = L.marker(coordonee, {icon: icon});
            return marker;
        }


        //Prepare et lie le text (civilite, nom, prenom, proffession)
        //param Marker, card
        //return Marker
        this.buildPopupContent = function (marker, card, place) {
            let content;

            switch (card.type) {
                case "PRO":
                    if (place !== undefined && place.institution !== undefined) {
                        content = self.buildProMobilePopup(card, place);
                    } else {
                        content = self.buildProPopup(card);
                    }
                    break;
                case "STRUCTURE":
                    if (place !== undefined && place.institution !== undefined) {
                        content = self.buildStructureMobilePopup(card, place);
                    } else {
                        content = self.buildStructurePopup(card);
                    }
                    break;
                default:
                    content = "";
            }

            content = "<div class='rescra-map-popup'>" + content + "</div>";

            marker.bindPopup(content);
            return marker;
        }

        this.buildProPopup = function (card) {
            let content = "";

            content += this.buildLinkToCard(card);
            content += this.buildTitle(card.frontoffice_name, "rescra-icon-pro");
            content += this.buildProAddress(card);
            if ("contacts" in card && card.contacts[0] !== undefined) {
                content += this.buildPhone(card.contacts[0].phone);
                content += this.buildEmail(card.contacts[0].email);
            }
            content += this.buildPlatformInfo(card.platform_list);

            return content;
        }

        // only if mobile + institution not null + gps coordinates not null
        this.buildProMobilePopup = function (card, place) {
            let content = "";

            content += this.buildLinkToCard(card);
            let title = this.buildProMobileTitle(card, place);
            content += this.buildTitle(title, "rescra-icon-pro");
            content += this.buildInstitutionAddress(place.institution);

            if ("contacts" in card && card.contacts[0] !== undefined) {
                content += this.buildPhone(card.contacts[0].phone);
                content += this.buildEmail(card.contacts[0].email);
            }

            content += this.buildMobileInfo(card, false);
            content += this.buildPlatformInfo(card.platform_list);

            return content;
        }

        this.buildProMobileTitle = function (card, place) {
            let title = place.institution.city + " - " + card.managers[0].lastname + " " + card.managers[0].firstname;

            switch (card.managers[0].title) {
                case "mme":
                    title += " (Mme)";
                    break;
                case "m":
                    title += " (M.)";
                    break;
                case "dr":
                    title += " (Dr.)";
                    break;
                case "pr":
                    title += " (Pr.)";
                    break;
            }
            return title;
        }

        this.buildStructurePopup = function (card) {
            let content = "";

            content += this.buildLinkToCard(card);
            let title = card.frontoffice_name;
            content += this.buildTitle(title, "rescra-icon-home");
            content += this.buildStructureAddress(card);

            if ("contacts" in card && card.contacts[0] !== undefined) {
                content += this.buildPhone(card.contacts[0].phone);
                content += this.buildEmail(card.contacts[0].email);
            }
            content += this.buildPlatformInfo(card.platform_list);
            return content;
        }

        this.buildStructureMobilePopup = function (card, place) {
            let content = "";

            content += this.buildLinkToCard(card);

            let title = place.institution.city + " - " + place.institution.label + " - " + card.structure_name;
            content += this.buildTitle(title, "rescra-icon-home");
            content += this.buildInstitutionAddress(place.institution);
            let phone = "";
            let email = "";

            if ("contacts" in card && card.contacts[0] !== undefined) {
                phone = card.contacts[0].phone;
                email = card.contacts[0].email;
            }

            content += this.buildPhone(phone);
            content += this.buildEmail(email);
            content += this.buildMobileInfo(card, true);
            content += this.buildPlatformInfo(card.platform_list);

            return content;
        }

        this.buildTitle = function (title, iconClass) {
            let content = "<div class='title-map-popup'>" +
                "<i class='rescra-icon " + iconClass + " rescra-icon-xsmall'></i> " + title +
                "</div>";
            return content;
        }

        this.buildLinkToCard = function (card) {
            let link = "";

            if (card !== undefined && card.full_card_url !== undefined && card.full_card_url !== null && card.full_card_url !== "") {
                link = "<div class='field-map-popup'><div class='data'>" +
                    "<a href='" + RESCRA_APP_URI + card.full_card_url +
                    "' target='_blank' data-toggle='modal' data-target='#modal-comment'  class='more-info cta-action-map'>" +
                    "<i class='link-icon rescra-icon-doc' aria-hidden='true'></i>" +
                    "<span class='link-content'>Voir la fiche complète</span></a>" +
                    "</div></div>";
            }

            return link;
        }

        this.buildCommonAddress = function (card, address) {

            if (card.address_1 !== "" && card.address_1 !== undefined && card.address_1 !== null) {
                address += card.address_1 + "<br>";
            }

            if('postbox' in card) {
                if (card.postbox !== "" && card.postbox !== undefined && card.postbox !== null) {
                    address += card.postbox + "<br>";
                }
            }

            if (card.postcode !== "" && card.postcode !== undefined && card.postcode !== null) {
                address += card.postcode + " ";
            }

            if (card.city !== "" && card.city !== undefined && card.city !== null) {
                address += card.city;
            }

            if (address !== "") {
                address = "<div class='field-map-popup'><i class='fa fa-map-marker icon'></i> <div class='data'>" + address + "</div></div>";
            }

            return address;
        }

        this.buildProAddress = function (card) {
            let address = "";

            if (card.job_place_label !== "" && card.job_place_label !== undefined && card.job_place_label !== null) {
                address += card.job_place_label + "<br>";
            }

            return this.buildCommonAddress(card, address);
        }


        this.buildStructureAddress = function (card) {
            let address = "";

            if (card.job_place_label !== "" && card.job_place_label !== undefined && card.job_place_label !== null) {
                address += card.job_place_label + "<br>";
            }

            return this.buildCommonAddress(card, address);
        }

        this.buildInstitutionAddress = function (institution) {
            let address = "";

            if (institution.label !== "" && institution.label !== undefined && institution.label !== null) {
                address += institution.label + "<br>";
            }

            return this.buildCommonAddress(institution, address);
        }

        this.buildPhone = function (phone) {
            let phoneHtml = "";

            if (phone !== undefined && phone !== null && phone !== "") {
                phoneHtml = "<div class='field-map-popup'><i class='fa fa-phone icon'></i> <div class='data'>" + phone + "</div></div>";
            }

            return phoneHtml;
        }

        this.buildEmail = function (email) {
            let emailHtml = "";

            if (email !== undefined && email !== null && email !== "") {
                emailHtml = "<div class='field-map-popup'><i class='fa fa-envelope-o icon'></i> " +
                    "<div class='data'>" +
                    "<a href='mailto:" + email + "'>" + email + "</a>" +
                    "</div></div>";
            }

            return emailHtml;
        }

        this.buildWebsiteLink = function (link) {
            let website = "";

            if (link !== undefined && link !== null && link !== "") {
                website = "<div class='field-map-popup'><i class='fa fa-link icon'></i> " +
                    "<div class='data'>" +
                    "<a href='" + link + "' target='_blank' >Site Internet</a>" +
                    "</div></div>";
            }

            return website;
        }

        this.buildMobileInfo = function (card, isTeam) {
            let teamInfo = "<div class='field-map-popup'>";
            teamInfo += (isTeam)
                ? "<span class='field-map-info'>Équipe intervenant sur d’autres sites </span> "
                : "<span class='field-map-info'>Professionnel intervenant sur d’autres sites </span>"
            ;
            /*if (!('job_place_label' in card) || !card.job_place_label) {
                teamInfo += (isTeam) ? "<span class='field-map-info'>Équipe intervenant sur d’autres sites </span> " : "<span class='field-map-info'>Professionnel intervenant sur d’autres sites </span>";
            } else {
                teamInfo += (isTeam) ? "<span class='field-map-info'>Équipe rattachée au site : </span> " : "<span class='field-map-info'>Professionnel rattaché au site : </span> ";
                teamInfo += "<span class='data'>" +
                    card.job_place_label + " - " + card.city +
                    "</span>";
            }*/
            teamInfo += '</div>';

            return teamInfo;
        }

        this.buildPlatformInfo = function (platformList) {
            let platformInfo = "";

            if (platformList !== undefined && Array.isArray(platformList)) {
                if (RESCRA.Config.Env.Current === RESCRA.Config.Env.Dev) {
                    // console.log(platformList);
                }
                platformList.forEach(function (platform) {
                    if(platform !== undefined && platform !== null){
                        platformInfo += "<div class='platform-linked-wrapper no-bg'>" +
                            "<i class='platform-linked-icon icon border-" + platform.theme + " " + platform.icon + "'></i>" +
                            " <span class='data'>" + platform.title + "</span></div>";
                    }
                });
            }

            return platformInfo;
        }

    }

    if (typeof (RESCRA_SEARCH_MAP_DATA_URL) !== 'undefined') {
        let RescraMaps = new RESCRA.Maps();
        RescraMaps.init();
    }


});


//Onverture de popup au clic de info+ sur les card de la map
$("#directory-map").on("click", ".cta-action-map", function () {
    let target = $(this).data("target");
    let themeClass = $(this).data("theme");
    let modalContent = $(target).find(".modal-body");

    // Ajax load content
    let href = $(this).attr("href");
    if (typeof href !== typeof undefined && href !== false) {
        let url = $(this).attr("href") + " #main-content";
        modalContent.load(url, function () {
            modalContent.find(".loader").remove();
            modalContent.removeClass().addClass("modal-body " + themeClass);
        });
    }
});
